<template>
  <div class="companies">
    <SectionHeader :title="$t('meta.weighStations')">
      <template v-slot:meta>
        <Link to="/weigh_stations/new" class="button button-green button-round button-small">
          {{ $t('weighStations.addStation') }}
        </Link>
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <SearchField
          v-if="weighStations && weighStations.length > 0"
          :label="$t('meta.search')"
          :name="'weigh-station-search-input'"
          :placeholder="$t('weighStations.searchPlaceholder')"
          v-model="searchPhrase"
          @input="searchHandler"
        />
        <LoadingSpinner v-if="loading && showLoadingSpinner" />
        <div v-else-if="weighStations && weighStations.length === 0" class="alert alert-no-entry">
          {{ $t('sensors.noSensors') }}
        </div>
        <div v-else class="content-wrap">
          <div class="content-body">
            <Table>
              <template #header>
                <th>{{ $t('meta.name') }}</th>
                <th>{{ $t('meta.location') }}</th>
                <th>{{ $t('meta.ip') }}</th>
                <th>{{ $t('meta.port') }}</th>
                <th>{{ $t('meta.unicornType') }}</th>
                <th></th>
              </template>
              <template #body>
                <tr v-for="{ uuid, name, area, zone, ip, port, unicorn_type } in weighStations" :key="uuid">
                  <td>{{ name }}</td>
                  <td>{{ area.name }}, {{ zone.name }}</td>
                  <td>{{ ip }}</td>
                  <td>{{ port }}</td>
                  <td>{{ unicorn_type }}</td>
                  <td class="table__actions">
                    <Link :to="`/company/weigh_stations/${uuid}`"><span class="material-icons">edit</span></Link>
                    <button @click="deleteStation(uuid)" class="table__action-button">
                      <span class="material-icons">delete</span>
                    </button>
                  </td>
                </tr>
              </template>
            </Table>
            <div v-if="pagination && pagination.totalObjects > 0" class="pagination">
              <pagination
                :records="pagination.totalObjects"
                v-model="pagination.page"
                :per-page="pagination.perPage"
                @paginate="getWeighStations"
                :options="{ chunk: 5, texts: { count: $t('pagination.text') } }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import Pagination from 'vue-pagination-2'

import SearchField from '@/components/Form/Search/SearchField'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import Table from '@/components/Table/index.vue'
import CompanyNav from '@/components/company_nav'

import weighStationsApi from '@/api/weighStations.js'
import { SEARCH_INPUT_DELAY } from '@/utils/searchInputDelay'

export default {
  name: 'WeighStationsIndex',
  inject: ['companyUser', 'showPopup'],
  data: () => ({
    currentPage: 1,
    loading: true,
    pagination: { page: 1, totalObjects: 0 },
    searchPhrase: '',
    showLoadingSpinner: true,
    weighStations: [],
  }),
  components: { CompanyNav, LoadingSpinner, Pagination, SearchField, SectionHeader, Table },
  computed: {
    searchHandler() {
      return debounce(
        () => {
          this.getWeighStations(1, false)
        },
        SEARCH_INPUT_DELAY,
        { trailing: true },
      )
    },
  },
  methods: {
    async getWeighStations(page = 1, showLoadingSpinner = true) {
      this.currentPage = page || this.pagination.page
      this.loading = true
      this.showLoadingSpinner = showLoadingSpinner

      const params = {
        company_uuid: this.companyUser.company_uuid,
        page: this.currentPage,
      }

      if (this.searchPhrase.length > 0) {
        params['search_phrase'] = this.searchPhrase
      }

      const result = await weighStationsApi.getAll(params)

      this.weighStations = result.weighStations
      this.pagination.page = this.currentPage
      this.pagination.totalObjects = result.pagination?.total_objects
      this.loading = false
      this.showLoadingSpinner = false
    },
    async deleteStation(stationUuid) {
      const confirmAlert = await this.showPopup({
        content: this.$t('weighStations.deleteConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const result = await weighStationsApi.delete(stationUuid)

      if (result.success) await this.getWeighStations(1)
    },
  },
  async mounted() {
    this.getWeighStations(1)
  },
}
</script>
